import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/_Core/_Services/notification.service';
import { CommonService } from 'src/app/_Core/_Services/common.service';
import { Router } from '@angular/router';
import { AdminService } from '../../../../services/admin.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  lastRefreshedTime: any = '';
  notificationState: boolean = false;
  notificationCount: number = 0;
  userType: any = localStorage.getItem('userType');
  parkDetails: any[] = [];
  selectedPark = localStorage.getItem('parkId');
  displayPark;
  userId = localStorage.getItem('userId') ? localStorage.getItem('userId') : 0;
  isReload = JSON.parse(localStorage.getItem('isReload'));
  adminName: string;
  parkTenantName: string;

  constructor(
    private appStateSrv: AppStateProvider,
    private router: Router,
    private notificationSrv: NotificationService,
    private commonService: CommonService,
    private adminSrv: AdminService
  ) {
    if (this.userId != 0) {
      console.log(this.userType);
      const getLoc = (this.userType == 'Parkite') ? this.commonService.getLocationPark() : this.commonService.getLocByTenatId()
      // if (this.userType == 'Parkite') {
      getLoc.subscribe((res) => {
        if (res.isValid) {
          this.commonService.getParkDropDownDetails().subscribe((res) => {
            this.parkDetails = res;
            localStorage.setItem(
              'parkDropDownDetails',
              JSON.stringify(this.parkDetails)
            );
            console.log(this.parkDetails);
            console.log(this.isReload)
            if (this.isReload == null || this.isReload == false) {
              localStorage.setItem('isReload', JSON.stringify(true))
              localStorage.setItem('locationId', ((localStorage.getItem('locationId')) ? (localStorage.getItem('locationId')) : this.parkDetails[0].locationId))
              this.setParkId((localStorage.getItem('parkId')) ? (localStorage.getItem('parkId')) : this.parkDetails[0].parkId)
            }
          });
        }
      });
    }
    this.parkDetails =
      this.parkDetails.length > 0
        ? this.parkDetails
        : JSON.parse(localStorage.getItem('parkDropDownDetails'));
    this.appStateSrv.getNotificationDrawerState().subscribe((status) => {

      this.notificationState = status;
    });
    console.log(this.parkDetails)

    this.notificationSrv.getSavedNotifications().subscribe((notifications) => {
      if (notifications !== null) this.getNotificationCount(notifications);
    });
    // this.appStateSrv.toggleNotificationsDrawer(this.notificationState)
  }

  getNotificationCount(notifications) {
    this.notificationCount = 0;
    notifications.forEach((notify) => {
      if (notify.isNew) this.notificationCount++;
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      console.log(this.parkDetails);
      if (localStorage.getItem('userType') == 'Bridge+') {
        this.adminSrv.getadmindetails().subscribe(details => {
          this.adminName = details?.data.adminName;
          this.parkTenantName = details?.data.tenant
        });
      } else {
        this.adminSrv.getParkiteAdmin().subscribe(details => {
          this.adminName = details?.data.adminName;
          this.parkTenantName = details?.data.parkTenantName
        });
      }
      this.parkDetails.forEach((element) => {
        if (this.selectedPark === element.parkId) {
          this.displayPark = element.parkName + ', ' + element.cityName;
        }
      });
    }
    this.lastRefreshedTime = this.appStateSrv.lastRefreshedTime();
  }

  toggleNotification() {
    this.notificationState = !this.notificationState;
    this.appStateSrv.toggleNotificationsDrawer(this.notificationState);
    this.notificationSrv.getAllNotifications().subscribe();
  }

  setParkId(event) {
    let locationId
    this.parkDetails.forEach((element) => {
      if (event === element.parkId) {
        this.displayPark = element.parkName + ', ' + element.cityName;
        localStorage.setItem('locationId', element.locationId)
      }
    });
    localStorage.setItem('parkId', event);
    console.log('abc');
    localStorage.removeItem('expandNav');
    const route = {
      index: '0',
      name: 'Overview',
      link: '/overview',
    };

    // this.router.navigate(['/overview']);

    // Retrieve stored redirect URL
    const redirectUrl = localStorage.getItem('redirectUrl');
    // localStorage.removeItem('redirectUrl'); // Clear after redirection

    if (redirectUrl && redirectUrl == '/vms/kiosk-invite') {
      this.router.navigateByUrl(redirectUrl);
    } else if (redirectUrl && redirectUrl == '/pms/pms-invite') {
      this.router.navigateByUrl(redirectUrl);
    } else {
      this.appStateSrv.setSideNavState(route);
      if (this.router.url.includes('overview')) {
        window.location.reload()
      }
    }
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }
}
